<template>

  <div class="card">
    <div class="card-header">
      Resultado
    </div>
    <div class="card-body">
      <svg class="cvf-chart" viewBox="-20 -20 540 540" width="520" height="520" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <!-- ✅ DIAG mais “para fora” (quase na borda do palco) -->
          <!-- raio 270 => topo em -20 (encaixa certinho no viewBox) -->
          <path id="circleText"
            d="M250 -15
              A265 265 0 1 1 249.999 -15" />
        </defs>

        <!-- ===================================================== -->
        <!-- ✅ ARTE INTERNA MAIOR -->
        <!-- rMax=235 | r70=165 | r30=71  (mantém 30/70/100) -->
        <!-- extremos: 250±235 => 15 e 485 -->
        <!-- ===================================================== -->

        <!-- CREATE -->
        <path d="M250 250 L485 250 A235 235 0 0 0 250 15 L250 85 A165 165 0 0 1 415 250 Z"
              fill="rgba(90,143,58,0.80)"/>
        <path d="M250 250 L415 250 A165 165 0 0 0 250 85 L250 179 A71 71 0 0 1 321 250 Z"
              fill="rgba(90,143,58,0.65)"/>
        <path d="M250 250 L321 250 A71 71 0 0 0 250 179 L250 250 Z"
              fill="rgba(90,143,58,0.50)"/>

        <!-- COLLABORATE -->
        <path d="M250 250 L250 15 A235 235 0 0 0 15 250 L85 250 A165 165 0 0 1 250 85 Z"
              fill="rgba(226,178,74,0.80)"/>
        <path d="M250 250 L250 85 A165 165 0 0 0 85 250 L179 250 A71 71 0 0 1 250 179 Z"
              fill="rgba(226,178,74,0.65)"/>
        <path d="M250 250 L250 179 A71 71 0 0 0 179 250 L250 250 Z"
              fill="rgba(226,178,74,0.50)"/>

        <!-- CONTROL -->
        <path d="M250 250 L15 250 A235 235 0 0 0 250 485 L250 415 A165 165 0 0 1 85 250 Z"
              fill="rgba(196,77,77,0.80)"/>
        <path d="M250 250 L85 250 A165 165 0 0 0 250 415 L250 321 A71 71 0 0 1 179 250 Z"
              fill="rgba(196,77,77,0.65)"/>
        <path d="M250 250 L179 250 A71 71 0 0 0 250 321 L250 250 Z"
              fill="rgba(196,77,77,0.50)"/>

        <!-- COMPETE -->
        <path d="M250 250 L250 485 A235 235 0 0 0 485 250 L415 250 A165 165 0 0 1 250 415 Z"
              fill="rgba(17,167,214,0.80)"/>
        <path d="M250 250 L250 415 A165 165 0 0 0 415 250 L321 250 A71 71 0 0 1 250 321 Z"
              fill="rgba(17,167,214,0.65)"/>
        <path d="M250 250 L250 321 A71 71 0 0 0 321 250 L250 250 Z"
              fill="rgba(17,167,214,0.50)"/>

        <!-- círculos (30 / 70 / 100) -->
        <circle cx="250" cy="250" r="71"  fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/>
        <circle cx="250" cy="250" r="165" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/>
        <circle cx="250" cy="250" r="235" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/>

        <!-- cruz principal -->
        <line x1="15"  y1="250" x2="485" y2="250" stroke="white" stroke-width="6"/>
        <line x1="250" y1="15"  x2="250" y2="485" stroke="white" stroke-width="6"/>

        <!-- diagonais finas -->
        <line x1="84" y1="84"  x2="416" y2="416" stroke="white" stroke-width="2" opacity="0.7"/>
        <line x1="84" y1="416" x2="416" y2="84"  stroke="white" stroke-width="2" opacity="0.7"/>

        <!-- textos internos -->
        <text x="355" y="160" text-anchor="middle" class="qTitle">Inovação</text>
        <text x="355" y="182" text-anchor="middle" class="qSub">fazer coisas novas</text>

        <text x="145" y="160" text-anchor="middle" class="qTitle">Colaboração</text>
        <text x="145" y="182" text-anchor="middle" class="qSub">fazer para durar</text>

        <text x="145" y="340" text-anchor="middle" class="qTitle">Controle</text>
        <text x="145" y="362" text-anchor="middle" class="qSub">fazer com precisão</text>

        <text x="355" y="340" text-anchor="middle" class="qTitle">Competição</text>
        <text x="355" y="362" text-anchor="middle" class="qSub">fazer acontecer agora</text>

        <!-- ===== OUTER (deixe encostado no quadro: mantido como você pediu) ===== -->
        <text x="250" y="-5" text-anchor="middle" class="outer">Flexível</text>
        <text x="510" y="255" text-anchor="middle" class="outer" transform="rotate(90 510 250)">Externo</text>
        <text x="250" y="515" text-anchor="middle" class="outer">Estável</text>
        <text x="-10" y="255" text-anchor="middle" class="outer" transform="rotate(-90 -10 250)">Interno</text>

        <!-- ✅ DIAG mais para fora -->
        <text class="diag"><textPath href="#circleText" startOffset="12.5%" text-anchor="middle">Crescimento</textPath></text>
        <text class="diag"><textPath href="#circleText" startOffset="37.5%" text-anchor="middle">Desempenho</textPath></text>
        <text class="diag"><textPath href="#circleText" startOffset="62.5%" text-anchor="middle">Precisão</textPath></text>
        <text class="diag"><textPath href="#circleText" startOffset="87.5%" text-anchor="middle">Engajamento</textPath></text>

        <!-- ===================================================== -->
        <!-- ✅ CAMADA DA ÁREA (re-escalada para rMax=235) -->
        <!-- ===================================================== -->
        <polygon
          :points="polygonPointsInline"
          fill="rgba(0,0,0,0.12)"
          stroke="rgba(0,0,0,0.75)"
          stroke-width="4"
          stroke-linejoin="round"
          stroke-linecap="round"
        />

        <!-- pontos (bolinhas) -->
        <circle :cx="polygonPointsFromScores[0][0]"   :cy="polygonPointsFromScores[0][1]" r="5" fill="#111"/>
        <circle :cx="polygonPointsFromScores[1][0]" :cy="polygonPointsFromScores[1][1]" r="5" fill="#111"/>
        <circle :cx="polygonPointsFromScores[2][0]" :cy="polygonPointsFromScores[2][1]" r="5" fill="#111"/>
        <circle :cx="polygonPointsFromScores[3][0]" :cy="polygonPointsFromScores[3][1]" r="5" fill="#111"/>
      </svg>
      <div class="mt-5">
        <div
          class="slider mt-3"
          v-for="(slider, index) in sliders"
          :key="index">
          <!--<div class="slider-title">{{ slider.title }}</div>-->
          <div class="slider-content">
            <VueSlider
              style="pointer-events: none;"
              :value="meta.axes[slider.name]"
              :min="-100"
              :max="100"
              :interval="1"
              :included="false"
              :process="false"
              :tooltip="'none'"
              :disabled="false"
              :clickable="false"
              :use-keyboard="false"
              :dot-size="16"
              :marks="[null, '0', null]"></VueSlider>
            <div class="slider-labels">
              <div class="slider-label" v-html="slider.labelLeft"></div>
              <div class="slider-label" v-html="slider.labelRight"></div>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-4">

      <div>
        <div
          class="mb-3"
          v-for="(q, index) in quadrants"
          :key="index">
          <div class="quadrant-label">
            <strong>{{ q.label }} <span :class="'text-' + q.levelColor">({{ q.level }})</span></strong>
          </div>
          <div class="quadrant-description">
            {{ q.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-header">
      Perfil
    </div>
    <div class="card-body">
      <p>{{ meta.content.profile.description }}</p>
      <p><b>Forma de trabalhar</b>: {{ meta.content.profile.working_style }}</p>
      <p><b>Ritmo de trabalho</b>: {{ meta.content.profile.communication_and_influence }}</p>
      <p><b>Autonomia e estrutura</b>: {{ meta.content.profile.autonomy_and_structure }}</p>
      <p><b>Toma de decisão</b>: {{ meta.content.profile.decision_making }}</p>
      <p><b>Foco natural de entrega</b>: {{ meta.content.profile.natural_delivery_focus }}</p>
      <p><b>Resposta a mudanças e pressão</b>: {{ meta.content.profile.change_and_pressure_response }}</p>
      <div class="mb-4">
        <div class="mb-2"><b>Pontos fortes</b></div>
        <ul>
          <li v-for="(point, index) in meta.content.profile.strengths" :key="index">{{ point }}</li>
        </ul>
      </div>
      <div class="mb-4">
        <div class="mb-2"><b>Pontos de atenção</b></div>
        <ul>
          <li v-for="(point, index) in meta.content.profile.weaknesses" :key="index">{{ point }}</li>
        </ul>
      </div>
      <p><b>Ambiente ideal</b>: {{ meta.content.profile.best_fit_environment }}</p>
      <p><b>Adição à cultura</b>: {{ meta.content.profile.culture_add }}</p>
    </div>
    
  </div>

</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'QuestionnairePersonalityQca',
  components: {
    VueSlider
  },
  props: [
    'meta'
  ],
  data () {
    return {
    }
  },
  computed: {
    percentiles () {
      return this.meta.percentiles
      // return {
      //   innovation: 30,
      //   collaboration: 35,
      //   control: 75,
      //   competition: 82
      // }
    },
    marks () {
      return [
        {
          value: 0,
          step: 1
        },
        {
          value: 50,
          step: 5
        },
        {
          value: 300,
          step: 10
        },
        {
          value: 800,
          step: 50
        }
      ]
    },
    quadrants () {
      const level = {
        'low': 'baixo',
        'medium': 'médio',
        'high': 'alto'
      }
      const levelColor = {
        'low': 'secondary',
        'medium': 'warning',
        'high': 'primary'
      }
      return [{
        name: 'innovation',
        label: 'Inovação',
        level: level[this.meta.levels.innovation],
        levelColor: levelColor[this.meta.levels.innovation],
        description: this.meta.content.quadrants.description.innovation
      }, {
        name: 'collaboration',
        label: 'Colaboração',
        level: level[this.meta.levels.collaboration],
        levelColor: levelColor[this.meta.levels.collaboration],
        description: this.meta.content.quadrants.description.collaboration
      }, {
        name: 'control',
        label: 'Controle',
        level: level[this.meta.levels.control],
        levelColor: levelColor[this.meta.levels.control],
        description: this.meta.content.quadrants.description.control
      }, {
        name: 'competition',
        label: 'Competição',
        level: level[this.meta.levels.competition],
        levelColor: levelColor[this.meta.levels.competition],
        description: this.meta.content.quadrants.description.competition
      }]
    },

    polygonPointsFromScores () {
      const scores = this.percentiles

      const cx = 250
      const cy = 250
      const rMax = 235

      // ângulos corretos pra seus quadrantes
      const anglesDeg = {
        innovation: 315, // CREATE (topo-direita)
        collaboration: 225, // COLLABORATE (topo-esquerda)
        control: 135, // CONTROL (baixo-esquerda)
        competition: 45 // COMPETE (baixo-direita)
      }

      // ordem ao redor (sem cruzar)
      const order = ['innovation', 'collaboration', 'control', 'competition']

      // normaliza: "100%" -> 100 | "100" -> 100 | 0.87 -> 87 | null/undefined -> 0
      const norm = (raw) => {
        let v = raw
        if (typeof v === 'string') v = parseFloat(v.replace('%', '').trim())
        v = Number(v)
        if (!Number.isFinite(v)) v = 0
        return Math.max(0, Math.min(100, v))
      }

      return order.map((k) => {
        const v = norm(scores[k])
        const r = rMax * (v / 100)
        const t = (anglesDeg[k] * Math.PI) / 180
        const x = cx + r * Math.cos(t)
        const y = cy + r * Math.sin(t)
        return [x.toFixed(1), y.toFixed(1)]
      })
    },
    polygonPointsInline () {
      return this.polygonPointsFromScores.map(p => p.join(',')).join(' ')
    },
    sliders () {
      return [
        {
          name: 'structure',
          labelLeft: '<b>Flexibilidade</b><br> (autonomia)',
          labelRight: '<b>Estabilidade</b><br> (estrutura)'
        },
        {
          name: 'focus',
          labelLeft: '<b>Foco interno</b><br>(pessoas, integração)',
          labelRight: '<b>Foco externo</b><br>(mercado, clientes)'
        },
        {
          name: 'relationship',
          labelLeft: '<b>Engajamento</b><br> (conexões, parcerias)',
          labelRight: '<b>Desempenho</b><br> (performance)'
        },
        {
          name: 'change',
          labelLeft: '<b>Precisão</b><br> (previsibilidade)',
          labelRight: '<b>Crescimento</b><br> (inovação, evolução)'
        }
      ]
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
.qTitle { font: 700 22px Arial, sans-serif; fill: #fff; }
.qSub   { font: italic 600 18px Arial, sans-serif; fill: rgba(255,255,255,0.9); }
.outer  { font: 600 18px Arial, sans-serif; fill: #8f969c; }
.diag   { font: 600 18px Arial, sans-serif; fill: rgba(143,150,156,0.7); }

.cvf-chart {
  width: 100%;
  height: auto;
  display: block;
}

.slider {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
  .slider > .slider-content {
    width: 100%;
    flex: 1;
  }
  .slider .slider-labels {
    display: flex;
    justify-content: space-between;
    margin: 0 0 0 0;
    gap: 40px;
    padding: 0;
  }
    .slider .slider-labels > .slider-label {
      flex: 1;
      color: #555;
    }
    .slider .slider-labels > .slider-label:nth-child(2) {
      text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnairePersonalityQca.vue